var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarn = function SvgWarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.874 1.316a.726.726 0 0 1 1.254 0l6.177 10.548a.726.726 0 0 1-.626 1.093H1.323a.726.726 0 0 1-.627-1.093L6.874 1.316Z",
    fill: "#F5A41D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.056 9.234 6.912 5.39h1.166l-.144 3.843h-.878Zm.445 1.974a.643.643 0 0 1-.472-.195.648.648 0 0 1-.195-.476c0-.188.065-.346.195-.476a.643.643 0 0 1 .472-.195.64.64 0 0 1 .476.195c.13.13.195.289.195.476a.648.648 0 0 1-.195.476.64.64 0 0 1-.476.195Z",
    fill: "#fff"
  })));
};
export default SvgWarn;